import { ContentTag } from '../../ContentTag/ContentTag.js';
import { getFileUploaderValuesStyles, getFileContentTagStyles, getFileContentTagContentStyles } from './FileUploaderValuesStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function FileUploaderValues(_ref) {
  let {
    values = [],
    onDelete,
    ...props
  } = _ref;
  return jsx("div", {
    css: getFileUploaderValuesStyles,
    ...props,
    children: values.map((file, index) => jsx(ContentTag, {
      css: getFileContentTagStyles,
      onClickRemove: () => onDelete(file),
      value: file.name,
      removeLabel: file.name,
      children: jsx("span", {
        css: getFileContentTagContentStyles,
        children: file.name
      })
    }, `${file.name}-${file.lastModified}-${index}`))
  });
}

export { FileUploaderValues };
//# sourceMappingURL=FileUploaderValues.js.map
